(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(vendorConfig);

    vendorConfig.$inject = [ /*Nothing*/ ];

    function vendorConfig() {

        var gsdk = {
            misc: {
                navbar_menu_visible: 0
            },
            initFiltersCollapse: function() {
                $(window).resize(function() {
                    if ($(window).width() < 992) {
                        $('.aside-filters .panel-title a, .panel-filters .panel-title a').addClass('collapsed');
                        $('.aside-filters .panel-collapse, .panel-filters .panel-collapse').removeClass('in');
                        $('#filters-panel').removeClass('in').css({ height: '' });
                        $('.card-refine').removeClass('card-plain');
                    } else {
                        $('#filters-panel').addClass('in');
                        $('.card-refine').addClass('card-plain');
                        //  $('.aside-filters .panel-collapse, .panel-filters .panel-collapse').addClass('in');
                    }
                });
                $(window).trigger('resize');
            },
            initNavSearchFormDisplay: function() {
                var $search = $('.ib-home-search');
                var $sm = $('.secondary-menu');

                var isVisibleOnTop = $search.is('.ib-search-form--visible-on-top');

                if (isVisibleOnTop) {
                    return;
                }
                if (!$sm.length) return;

                var wScrollTop = $(window).scrollTop();
                if (wScrollTop > $sm.offset().top) {
                    $search.addClass('.search-hidden');
                } else {
                    $search.removeClass('.search-hidden');
                }
            },
            initShuffle: function() {

                var $grid = $('.shuffle'),
                    $sizer = $grid.find(':first');

                $grid.shuffle({
                    itemSelector: 'div',
                    sizer: $sizer
                });


            },

            initLeftMenu: function() {
                if (!navbar_initialized) {
                    if(!angular.isDefined($navbar))
                        var $navbar;
                    $navbar = $('.navbar-collapse');


                    $navbar.css('min-height', window.screen.height);

                    // ul_content = '';

                    // $navbar.children('ul').each(function(){
                    //    content_buff = $(this).html();
                    //    ul_content = ul_content + content_buff;
                    // });

                    // ul_content = '<ul class="nav navbar-nav">' + ul_content + '</ul>';
                    // $navbar.html(ul_content);

                    // $('body').append($navbar);

                    // background_image = $navbar.data('nav-image');
                    // if(background_image != undefined){
                    //    $navbar.css('background',"url('" + background_image + "')")
                    //           .removeAttr('data-nav-image')
                    //           .css('background-size',"cover")
                    //           .addClass('has-image');
                    // }


                    if(!angular.isDefined($toggle))
                        var $toggle;
                    $toggle = $('.navbar-toggle');

                    // $navbar.find('a').removeClass('btn btn-round btn-default');
                    $navbar.find('button').removeClass('btn-round btn-fill btn-info btn-primary btn-success btn-danger btn-warning btn-neutral');
                    $navbar.find('button').addClass('btn-simple btn-block');

                    $toggle.click(function() {
                        if (gsdk.misc.navbar_menu_visible == 1) {
                            $('html').removeClass('nav-open');
                            gsdk.misc.navbar_menu_visible = 0;
                            $('#bodyClick').remove();
                            setTimeout(function() {
                                $toggle.removeClass('toggled');
                            }, 400);

                        } else {
                            setTimeout(function() {
                                $toggle.addClass('toggled');
                            }, 430);

                            div = '<div id="bodyClick"></div>';
                            $(div).appendTo("body").click(function() {
                                $('html').removeClass('nav-open');
                                gsdk.misc.navbar_menu_visible = 0;
                                $('#bodyClick').remove();
                                setTimeout(function() {
                                    $toggle.removeClass('toggled');
                                }, 400);
                            });

                            $('html').addClass('nav-open');
                            gsdk.misc.navbar_menu_visible = 1;

                        }
                    });
                    navbar_initialized = true;
                }

            },

            checkScrollForTransparentNavbar: debounce(function() {
                if ($(document).scrollTop() > 160) {
                    // if(transparent) {
                    // transparent = false;
                    $('nav[role="navigation"]').removeClass('navbar-transparent');
                    $('body').removeClass('header-transparent');
                    // }
                } else {
                    // if( !transparent ) {
                    // transparent = true;
                    $('nav[role="navigation"]').addClass('navbar-transparent');
                    $('body').addClass('header-transparent');
                    // }
                }
            }, 17),

            fitBackgroundForCards: function() {
                $('.card').each(function() {
                    if (!$(this).hasClass('card-product') && !$(this).hasClass('card-image')) {
                        image = $(this).find('.image img');
                        if (image.length) {
                            image.hide();
                            image_src = image.attr('src');

                            $(this).find('.image').css({
                                "background-image": "url('" + image_src + "')",
                                "background-position": "top center",
                                "background-size": "cover"
                            });
                        }
                    }
                });
            },
            initPopovers: function() {
                if ($('[data-toggle="popover"]').length != 0) {
                    $('body').append('<div class="popover-filter"></div>');

                    //    Activate Popovers
                    $('[data-toggle="popover"]').popover().on('show.bs.popover', function() {
                        $('.popover-filter').click(function() {
                            $(this).removeClass('in');
                            $('[data-toggle="popover"]').popover('hide');
                        });
                        $('.popover-filter').addClass('in');
                    }).on('hide.bs.popover', function() {
                        $('.popover-filter').removeClass('in');
                    });

                }
            },

            initSliders: function() {
                // Sliders for demo purpose in refine cards section
                // if($('#slider-range').length != 0){
                //     $( "#slider-range" ).slider({
                //      range: true,
                //      min: 100,
                //      max: 500,
                //         step: 50,
                //      values: [ 100, 500 ],
                //         slide: function( event, ui ) {
                //             min_price = ui.values[0];
                //             max_price = ui.values[1];
                //             console.log(this);
                //             $(this).next('.from-to-input').find('.from').val(min_price );
                //             $(this).next('.from-to-input').find('.to').val(max_price )
                //         }
                //  });
                // }
                // if($('#amount-slider').length != 0){
                //   $( "#amount-slider" ).slider({
                //      range: false,
                //      min: 1000,
                //      max: 50000,
                //      value: 25000,
                //         step: 1000,
                //      slide: function( event, ui ) {
                //          price = ui.value;
                //          $(this).siblings('.amount').html(price + " PLN");

                //      }
                //  });
                // }
                // if($('#slider-default').length != 0 || $('#slider-default2').length != 0){
                //  $( "#slider-default, #slider-default2" ).slider({
                //          value: 70,
                //          orientation: "horizontal",
                //          range: "min",
                //          animate: true
                //  });
                // }
            },
            initVideoCards: function() {


                $('[data-toggle="video"]').click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log(e);



                    var id_video = $(this).data('video');
                    var video = $('#' + id_video).get(0);

                    var $card = $(this).closest('.card');
                    // console.log($card,id_video, video);

                    if (video.paused) {
                        video.play();
                        $card.find('.fa-pause,.fa-play').parent().html('<i class="fa fa-pause"></i> Pause');
                        $card.addClass('state-play');
                    } else {
                        video.pause();
                        $card.find('.fa-pause,.fa-play').parent().html('<i class="fa fa-play"></i> Play');
                        $card.removeClass('state-play');
                    }
                });
            },
            initNavbarSearch: function() {
                $('[data-toggle="search"]').click(function() {
                    if (searchVisible == 0) {
                        searchVisible = 1;
                        $(this).parent().addClass('active');
                        $('.navbar-search-form').fadeIn(function() {
                            $('.navbar-search-form input').focus();
                        });
                    } else {
                        searchVisible = 0;
                        $(this).parent().removeClass('active');
                        $(this).blur();
                        $('.navbar-search-form').fadeOut(function() {
                            $('.navbar-search-form input').blur();
                        });
                    }
                });
            },
            initMasonry: function() {

                // var msnry = new Masonry( '.masonry', {
                //   // options
                //   // itemSelector: '.',
                //   // columnWidth: 200
                // });


            },
            initSlickSliders: function() {
                //    $('#slickCarousel').slick({
                //         dots: true,
                //         infinite: false,
                //         speed: 300,
                //         slidesToShow: 3,
                //         slidesToScroll: 2,
                //         prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
                //         nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
                //         responsive: [
                //           {
                //             breakpoint: 1024,
                //             settings: {
                //               slidesToShow: 3,
                //               slidesToScroll: 2,
                //               infinite: true,
                //               dots: true
                //             }
                //           },
                //           {
                //             breakpoint: 700,
                //             settings: {
                //               slidesToShow: 2,
                //               slidesToScroll: 1
                //             }
                //           },
                //           {
                //             breakpoint: 580,
                //             settings: {
                //               slidesToShow: 1,
                //               slidesToScroll: 1
                //             }
                //           }
                //           // You can unslick at a given breakpoint now by adding:
                //           // settings: "unslick"
                //           // instead of a settings object
                //         ]
                //     });


            }
        };

        /**
         * jquery.matchHeight-min.js master
         * http://brm.io/jquery-match-height/
         * License: MIT
         */
        (function(c) {
            var n = -1,
                f = -1,
                g = function(a) {
                    return parseFloat(a) || 0
                },
                r = function(a) {
                    var b = null,
                        d = [];
                    c(a).each(function() {
                        var a = c(this),
                            k = a.offset().top - g(a.css("margin-top")),
                            l = 0 < d.length ? d[d.length - 1] : null;
                        null === l ? d.push(a) : 1 >= Math.floor(Math.abs(b - k)) ? d[d.length - 1] = l.add(a) : d.push(a);
                        b = k
                    });
                    return d
                },
                p = function(a) {
                    var b = { byRow: !0, property: "height", target: null, remove: !1 };
                    if ("object" === typeof a) return c.extend(b, a);
                    "boolean" === typeof a ? b.byRow = a : "remove" === a && (b.remove = !0);
                    return b
                },
                b = c.fn.matchHeight =
                function(a) {
                    a = p(a);
                    if (a.remove) {
                        var e = this;
                        this.css(a.property, "");
                        c.each(b._groups, function(a, b) { b.elements = b.elements.not(e) });
                        return this
                    }
                    if (1 >= this.length && !a.target) return this;
                    b._groups.push({ elements: this, options: a });
                    b._apply(this, a);
                    return this
                };
            b._groups = [];
            b._throttle = 80;
            b._maintainScroll = !1;
            b._beforeUpdate = null;
            b._afterUpdate = null;
            b._apply = function(a, e) {
                var d = p(e),
                    h = c(a),
                    k = [h],
                    l = c(window).scrollTop(),
                    f = c("html").outerHeight(!0),
                    m = h.parents().filter(":hidden");
                m.each(function() {
                    var a = c(this);
                    a.data("style-cache", a.attr("style"))
                });
                m.css("display", "block");
                d.byRow && !d.target && (h.each(function() {
                    var a = c(this),
                        b = a.css("display");
                    "inline-block" !== b && "inline-flex" !== b && (b = "block");
                    a.data("style-cache", a.attr("style"));
                    a.css({ display: b, "padding-top": "0", "padding-bottom": "0", "margin-top": "0", "margin-bottom": "0", "border-top-width": "0", "border-bottom-width": "0", height: "100px" })
                }), k = r(h), h.each(function() {
                    var a = c(this);
                    a.attr("style", a.data("style-cache") || "")
                }));
                c.each(k, function(a, b) {
                    var e = c(b),
                        f = 0;
                    if (d.target) f = d.target.outerHeight(!1);
                    else {
                        if (d.byRow && 1 >= e.length) {
                            e.css(d.property, "");
                            return
                        }
                        e.each(function() {
                            var a = c(this),
                                b = a.css("display");
                            "inline-block" !== b && "inline-flex" !== b && (b = "block");
                            b = { display: b };
                            b[d.property] = "";
                            a.css(b);
                            a.outerHeight(!1) > f && (f = a.outerHeight(!1));
                            a.css("display", "")
                        })
                    }
                    e.each(function() {
                        var a = c(this),
                            b = 0;
                        d.target && a.is(d.target) || ("border-box" !== a.css("box-sizing") && (b += g(a.css("border-top-width")) + g(a.css("border-bottom-width")), b += g(a.css("padding-top")) + g(a.css("padding-bottom"))),
                            a.css(d.property, f - b + "px"))
                    })
                });
                m.each(function() {
                    var a = c(this);
                    a.attr("style", a.data("style-cache") || null)
                });
                b._maintainScroll && c(window).scrollTop(l / f * c("html").outerHeight(!0));
                return this
            };
            b._applyDataApi = function() {
                var a = {};
                c("[data-match-height], [data-mh]").each(function() {
                    var b = c(this),
                        d = b.attr("data-mh") || b.attr("data-match-height");
                    a[d] = d in a ? a[d].add(b) : b
                });
                c.each(a, function() { this.matchHeight(!0) })
            };
            var q = function(a) {
                b._beforeUpdate && b._beforeUpdate(a, b._groups);
                c.each(b._groups, function() {
                    b._apply(this.elements,
                        this.options)
                });
                b._afterUpdate && b._afterUpdate(a, b._groups)
            };
            b._update = function(a, e) {
                if (e && "resize" === e.type) {
                    var d = c(window).width();
                    if (d === n) return;
                    n = d
                }
                a ? -1 === f && (f = setTimeout(function() {
                    q(e);
                    f = -1
                }, b._throttle)) : q(e)
            };
            c(b._applyDataApi);
            c(window).bind("load", function(a) { b._update(!1, a) });
            c(window).bind("resize orientationchange", function(a) { b._update(!0, a) })
        })(jQuery);


        /* chartist-plugin-pointlabels 0.0.7
         * Copyright © 2015 Gion Kunz
         * Free to use under the WTFPL license.
         * http://www.wtfpl.net/
         */

        // !function(a,b){"function"==typeof define&&define.amd?define([],function(){return a.returnExportsGlobal=b()}):"object"==typeof exports?module.exports=b():a["Chartist.plugins.tooltips"]=b()}(this,function(){return function(a,b,c){"use strict";var d={currency:void 0};c.plugins=c.plugins||{},c.plugins.tooltip=function(a){return a=c.extend({},d,a),function(b){var d=".ct-point";b instanceof c.Bar?d=".ct-bar":b instanceof c.Pie&&(d=".ct-slice");var e=$(b.container),f=e.append('<div class="chartist-tooltip"></div>').find(".chartist-tooltip").hide();e.on("mouseenter",d,function(){var d=$(this),e="";if(a.tooltipFnc)e=a.tooltipFnc(d.attr("ct:meta")||"",d.attr("ct:value"));else{if(d.attr("ct:meta"))e+=d.attr("ct:meta")+"<br/>";else if(b instanceof c.Pie){var g=d.next(".ct-label");g.length>0&&(e+=g.text()+"<br/>")}var h=d.attr("ct:value");$.isEmptyObject(a.currency)||(h=a.currency+h.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g,"$1,")),e+=h}f.html(e).show()}),e.on("mouseleave",d,function(){f.hide()}),e.on("mousemove",function(a){f.css({left:(a.originalEvent.layerX||a.offsetX)-f.width()/2-10,top:(a.originalEvent.layerY||a.offsetY)-f.height()-40})})}}}(window,document,Chartist),Chartist.plugins.tooltips});
        //# sourceMappingURL=chartist-plugin-tooltip.min.js.map



        /**
         * Polish translation for bootstrap-datepicker
         * Robert <rtpm@gazeta.pl>
         */
        ;
        (function($) {
            $.fn.datepicker.dates['pl'] = {
                days: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
                daysShort: ["niedz.", "pon.", "wt.", "śr.", "czw.", "piąt.", "sob."],
                daysMin: ["ndz.", "pn.", "wt.", "śr.", "czw.", "pt.", "sob."],
                months: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                monthsShort: ["sty.", "lut.", "mar.", "kwi.", "maj", "cze.", "lip.", "sie.", "wrz.", "paź.", "lis.", "gru."],
                today: "dzisiaj",
                weekStart: 1,
                clear: "wyczyść",
                format: "dd.mm.yyyy"
            };
        }(jQuery));

        var searchVisible = 0;
        var transparent = true;

        var transparentDemo = true;
        var fixedTop = false;

        var navbar_initialized = false;

        function isTouchDevice() {
            var el = document.createElement('div');
            el.setAttribute('ongesturestart', 'return;'); // or try "ontouchstart"
            return typeof el.ongesturestart === "function";
        }

        $(document).ready(function() {
            var window_width = $(window).width();


            // Init search form display
            gsdk.initNavSearchFormDisplay();

            // Init navigation toggle for small screens
            // if(window_width < 768){
            //  gsdk.initLeftMenu();
            // }

            // Activate Morpghing Buttons
            $('[data-toggle="morphing"]').each(function() {
                $(this).morphingButton();
            });

            //  Activate the tooltips
            $('[rel="tooltip"]').tooltip();

            //      Activate the switches with icons
            if ($('.switch').length != 0) {
                $('.switch')['bootstrapSwitch']();
            }
            //      Activate regular switches
            if ($("[data-toggle='switch']").length != 0) {
                $("[data-toggle='switch']").wrap('<div class="switch"></div>').parent().bootstrapSwitch();
            }

            //    Activate bootstrap-select
            if ($(".selectpicker").length != 0) {
                $(".selectpicker").selectpicker();
            }

            // if($(".tagsinput").length != 0){
            //     $(".tagsinput").tagsInput();
            // }

            if ($('.date-picker').length != 0) {
                $('.date-picker').datepicker({
                    weekStart: 1,
                    format: 'dd/mm/yyyy',
                    language: 'pl',
                    orientation: 'auto right'
                });
            }
            //
            // if( $('.masonry').length != 0 ){
            //     gsdk.initMasonry();
            // }


            $('.btn-tooltip').tooltip();
            $('.label-tooltip').tooltip();




            $('.form-control').on("focus", function() {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function() {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });

            // demo.initPickColor();

            // Make the images from the card fill the hole space
            gsdk.fitBackgroundForCards();

            // Init icon search action for the navbar
            // gsdk.initNavbarSearch();

            // Init popovers
            // gsdk.initPopovers();

            // Init Collapse Areas
            // gsdk.initCollapseArea();

            // Init Sliders
            // gsdk.initSliders();

            //  Init video card actions
            gsdk.initVideoCards();
            gsdk.initFiltersCollapse();

            $(window).on('scroll', gsdk.checkScrollForTransparentNavbar);
            $(window).trigger('resize');
            $(window).trigger('scroll');

            // gsdk.checkScrollForTransparentNavbar();

        });


        /**
         * Table row toggle
         * podsumowanie-umow-leasingowych.php
         */
        $(function() {

            $('[data-js-slide-table-trigger]').on('click', function(e) {
                e.preventDefault();
                var id = $(this).data('js-slide-table-trigger');
                // var $tr = $(this).parent();
                var $details = $(id);
                var $tr = $details.closest('tr').prev();
                //
                if ($details.hasClass('visible')) {
                    $details.slideUp('fast');
                    $details.removeClass('visible');
                    $tr.delay(111).show('slow');
                } else {
                    $details.slideDown('fast');
                    $details.addClass('visible');
                    $tr.hide();
                }
            });

        });

        /**
         * Cards equal height settings.php
         */
        $(function() {

            $('.grid .content').matchHeight({
                byRow: true
            });


        });

        // activate collapse right menu when the windows is resized
        $(window).resize(function() {
            if ($(window).width() < 768) {
                gsdk.initLeftMenu();
            }
        });

        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        };





        // jQuery(function () {
        //   $('[data-placeholder-animate]').each(function (i, el) {
        //     var $el = $(el);
        //     var timeoutId;
        //     var placeholder = $el.attr('placeholder');
        //     var currentPos = 0;
        //     // console.log( placeholder, placeholder.length )
        //     // var currentPos = 0;
        //     $el.on('focusin', function (e) {
        //        $el.attr("placeholder", '' );
        //       if( timeoutId ) clearTimeout(timeoutId);

        //     });
        //     $el.on('focusout', function (e) {
        //       if( $el.val() == '' )
        //       {
        //         setTimeout(animation, 100);
        //       }
        //     }).trigger('focusout');

        //     function animation() {

        //       // var placeholder = $el.attr('placeholder');
        //       var text = placeholder.substr(0, currentPos++);
        //       // console.log( currentPos, placeholder.length );
        //       $el.attr("placeholder", text );

        //       if( currentPos == placeholder.length+1 ){
        //         currentPos = 0;
        //         var timeout = 1000;
        //       }else{
        //         var timeout = 100;
        //       }

        //       timeoutId = setTimeout(animation,  timeout);
        //     }

        //   });
        // });


    }
})();
